/**
 * Получение из ответа текста ошибки от SOWA.
 * Функция связана с SowaError.
 */
export const extractSowaErrorText = (responseText: string) => {
  return responseText.match(/error.*in.*(request|response).*body/i)?.[0];
};
